import { useMemo } from 'react';
import type { Service } from '../../types/api';
import { Button } from '../ui';
import { summary } from '../../utils/text';
import CardShowcase from './CardShowcase';
import { clamp3, type ShowcaseEntry } from './showcase';

/** « Ce que nous faisons »: un onglet par service, en mise en page compacte (peu d'éléments par service). */
export default function ServicesShowcase({ services }: { services: Service[] }) {
  const entries: ShowcaseEntry[] = useMemo(
    () => services.filter((s) => s.enable && s.cover_image?.url).map((s) => ({
      id: s.id,
      label: s.name,
      image: s.cover_image!.url,
      alt: s.name,
      content: (
        <div>
          <div className="text-xs font-semibold uppercase tracking-[0.0625rem] text-ink">{s.sector?.name ?? 'Service'}</div>
          <h3 className="mt-4 text-inherit font-display text-[1.75rem] font-bold normal-case leading-[1.1] tracking-normal md:text-[2.25rem]" style={clamp3}>{s.name}</h3>
          <p className="mt-5 text-[1rem] leading-relaxed text-black">{summary(s.description, 340, 3)}</p>
          <div className="mt-8"><Button to={`/services/${s.id}`} variant="secondary">En savoir plus</Button></div>
        </div>
      ),
    })),
    [services],
  );
  return <CardShowcase eyebrow="Ce que nous faisons" heading="Une expertise complète, de l'étude à la livraison." entries={entries} />;
}
